import mainLogo from '../images/Itavema/itavema_logo_main_color.png';
import squareLogo from '../images/Itavema/itavema_logo_squareSmall_color.png';
import squareLogoLarge from '../images/Itavema/itavema_logo_mainSmall_color.png';
import bannerLogoWhite from '../images/Itavema/itavema_logo_main_white.png';
import banner01 from '../images/Itavema/itavema_bg_01.jpg';
import banner02 from '../images/Itavema/carros_faixa_ItavemaBrands_2.jpg';
import banner03 from '../images/Itavema/itavema_bg_02.jpg';
import bannerImg01 from '../images/Itavema/itavema_bannerImg_01_400x400_logo.png';
import car123 from '../images/Itavema/123_creta.jpg';
import box123 from '../images/Itavema/123_itavema.jpg';
import { SliderProducts } from '../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Itavema',
    defaultStoreLink: 'pecas.itavema.com.br',
    defaultContactEmail: 'atendimentosite@itavema.com.br',
    whatsappNumber: '11 3646 4945',
    CNPJname: 'ITVA COMERCIO DE VEICULOS LTDA',
    CNPJ: '07.512.967/0027-30',
    CNPJaddress: 'Av. Dr. Gastão Vidigal, 2571 - Vila Leopoldina, São Paulo - SP, CEP: 05314-001',
    launchDate: '07/09/2024',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "byd",
        "fiat",
        "hyundai",
        "renault",
        // "nissan",
        "toyota",
        "volvo",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "Itavema France Pinheiros",
        "ITVA FIAT NOVA IGUACU",
        "ITVA HYUNDAI CAMPO GRANDE",
        "TOYOTA BOTAFOGO",
        "ITVA VOLVO VILA OLIMPIA",
        "TOYOTA GASTÃO VIDIGAL",
        "Itavema France Guarulhos",
        // "ITAVEMA JAPAN GASTAO VIDIGAL", //Itavema Nissan Off
        "ITAVEMA BYD NOVA IGUACU",
    ],
    
    disabledSellers: [
        "ITAVEMA JAPAN GASTAO VIDIGAL", //Itavema Nissan Off
    ],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
            },
        {
            name: 'Roupas',
            img: 'tabRoupas',
            products: SliderProducts.Roupas
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,
    
    bannerImg01: bannerImg01,
    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: '',
    bannerBrands: banner02,
    aboutUsBg: banner03,
    car123: car123,
    box123: box123,
    
    paymentImg: squareLogoLarge,
    paymentImgMobile: squareLogoLarge,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças <span style="font-weight: bold;">originais</span> compatíveis com seu veículo, direto das concessionárias <span style="font-weight: bold;">Itavema</span>.',
    aboutUs: {
        title: 'Quem somos',
        content: [
            'Mais de 50 anos de história e credibilidade. Com unidades no estado de São Paulo e do Rio de Janeiro,  o Grupo Itavema é sinônimo de qualidade e confiança.',
            'O Grupo Itavema, que começou suas operações no final da década de 60 na cidade de São Paulo representa hoje, importantes montadoras do cenário nacional: Renault, Toyota, Volvo, Fiat, Hyundai, BYD, KTM e Dafra.',
            'Prezando pela excelência no atendimento aos nossos clientes, as lojas do Grupo Itavema oferecem ao público opções em veículos 0km, seminovos e na prestação dos serviços pós-venda, através das revisões periódicas, fornecimento de peças e reparos.',
        ],
        link: 'https://itavema.com.br/quem-somos',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/grupoitavema/',
        Facebook: 'https://www.facebook.com/grupoitavema',
        LinkedIn: 'https://www.linkedin.com/company/grupo-itavema/',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}